import { takeLatest, call, put } from "redux-saga/effects";

import AudioFileService from "../../../services/AudioFile/AudioFileService";
import * as types from "../actionTypes";

export function* addAudioFileReviewWatcherSaga() {
  yield takeLatest(types.API_V1_AUDIO_FILE_REVIEW_REQUEST, workerSaga);
}

export function* workerSaga({ action, index, accountId, audioFileId, data }) {
  try {
    if (action === "APPROVE") {
      yield call(AudioFileService.approveAudioFile, accountId, audioFileId);
    } else if (action === "REJECT") {
      yield call(
        AudioFileService.rejectAudioFile,
        accountId,
        audioFileId,
        data
      );
    }
    yield put({
      type: types.API_V1_AUDIO_FILE_REVIEW_SUCCESS,
      payload: { index, accountId },
    });
  } catch (error) {
    yield put({ type: types.API_V1_AUDIO_FILE_REVIEW_FAILURE });
    return { error: error };
  }
}
